import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { Button } from "../components/ui/button";

const cookieText = {
  it: {
    title: "Utilizziamo i cookie",
    description:
      "Questo sito utilizza cookie tecnici necessari al funzionamento e cookie analitici per migliorare la tua esperienza di navigazione. Puoi accettare o rifiutare i cookie non essenziali.",
    accept: "Accetta tutto",
    reject: "Rifiuta",
    policy: "Leggi la Privacy Policy",
  },
  en: {
    title: "We use cookies",
    description:
      "This website uses technical cookies necessary for operation and analytics cookies to improve your browsing experience. You can accept or reject non-essential cookies.",
    accept: "Accept all",
    reject: "Reject",
    policy: "Read Privacy Policy",
  },
};

export default function CookieBanner({ lang = "it" }) {
  const [visible, setVisible] = useState(true);

  const handleAccept = () => {
    setVisible(false);
  };

  const handleReject = () => {
    setVisible(false);
  };

  const t = cookieText[lang] || cookieText.it;

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-0 z-[9998] print:hidden flex items-end justify-center"
    >
      {/* Overlay scuro che blocca l'interazione */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Banner */}
      <div className="relative w-full bg-[#0A0A0A] border-t border-white/10 shadow-2xl animate-in slide-in-from-bottom duration-500">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
            <div className="flex items-start gap-3 flex-1">
              <Cookie className="w-6 h-6 text-[#002FA7] shrink-0 mt-0.5" />
              <div>
                <p className="text-base font-semibold text-white mb-1">{t.title}</p>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {t.description}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
              <Button
                data-testid="cookie-reject-button"
                variant="outline"
                size="default"
                onClick={handleReject}
                className="bg-transparent border-white/20 text-slate-300 hover:bg-white/10 hover:text-white rounded-full flex-1 md:flex-initial px-6"
              >
                {t.reject}
              </Button>
              <Button
                data-testid="cookie-accept-button"
                size="default"
                onClick={handleAccept}
                className="bg-[#002FA7] text-white hover:bg-[#001f75] rounded-full flex-1 md:flex-initial px-6"
              >
                {t.accept}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
